import cn from 'clsx'

import css from './Em.module.css'

export function Em({
    children,
    className,
    ...rest
}: React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>) {
    return (
        <em className={cn(css.em, className)} {...rest}>
            {children}
        </em>
    )
}
